import React from "react";

const ProfileStregthContext = React.createContext({
  score: 0,
  missing: [],
  indicator: "yellow",
});

export default ProfileStregthContext;
